export default "__VITE_ASSET__6V$Qgh8Z__"